// Data Shape for addOnSelections:
// {
//   [baseProductSku AKA baseSku]: {
//     [addOnSku]: [selectionValue]
//   }
// }
export default {
  namespaced: true,
  state: () => ({
    data: {}
  }),
  // If you ONLY need data retrieval, use getters.
  getters: {
    selections(state) {
      return state
    },
    selection: state => (payload = { baseSku: '', addOnSku: '' }) => {
      const { baseSku, addOnSku } = payload
      const exists = state.data[baseSku] && state.data[baseSku][addOnSku]
      const result = exists ? state.data[baseSku][addOnSku] : '0'
      return result
    }
  },
  // If you need to change data, use mutations.
  mutations: {
    saveSelection(state, payload = {baseSku: '', addOnSku: '', selection: ''}) {
      const { baseSku, addOnSku, selection } = payload
      const newState = {
        ...state.data
      }
      state.data = newState
      state.data[baseSku] = {
        [addOnSku]: selection
      }
    }
  },
  // If you need to change data Asynchronously, use actions.
}
